export default __webpack_public_path__ + "static/media/scroll5.f1993284.jpg";